import { render } from "./ShopDelete.vue?vue&type=template&id=40c7150e&ts=true"
import script from "./ShopDelete.vue?vue&type=script&lang=ts"
export * from "./ShopDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__